import '@/vendors';
import * as plugins from '@/plugins';
import { loadModules } from '@/helpers/modules-loader';
import { onDomReady } from '@/helpers/utils';

onDomReady().then(() => {
	Object.values(plugins).forEach((factory) => factory());
	loadModules();
});
